import { Card, CardContent, CardTitle, CardHeader, Button } from 'app-template-lib/components/shadcn';
import { ChevronRight } from 'lucide-react';
import { MouseEventHandler, useCallback } from 'react';

export interface DivisionCardProps {
    soshikiDivisions: { id: string; division_name: string | null | undefined; jigyoCount: number | null | undefined }[];
    visibleJigyoCount?: boolean;
    onClickDivisionButton: (value: string) => void;
}

export function DivisionCards({ soshikiDivisions, visibleJigyoCount = true, onClickDivisionButton }: DivisionCardProps) {
    /**
     * 事業カードクリック時のイベントハンドラ
     * @param event
     */
    const handleClickDivisionCard: MouseEventHandler<HTMLButtonElement> = useCallback(
        (event) => {
            if (onClickDivisionButton) {
                onClickDivisionButton(event.currentTarget.value);
            }
        },
        [onClickDivisionButton]
    );

    return (
        <Card className="bg-secondary rounded-t-xl my-5 shadow-none border-none mx-2 md:mx-0">
            <CardHeader className="bg-primary rounded-t-xl">
                <CardTitle className="text-white font-normal">組織から事業を確認する</CardTitle>
            </CardHeader>
            <CardContent className="container mx-auto grid grid-cols-1 lg:grid-cols-[3fr_3fr_3fr]  shadow-none border-none pt-3 p-3 gap-2">
                {soshikiDivisions.map((division) => (
                    <Button
                        key={division.id}
                        variant={'ghost'}
                        value={division.id}
                        onClick={handleClickDivisionCard}
                        className="min-w-fit h-full p-4 rounded-xl border-card bg-card shadow-none border-none items-center flex justify-between "
                    >
                        <h3 className="text-sm text-wrap">{division.division_name}</h3>
                        <div className="flex justify-between items-center">
                            {/* {visibleJigyoCount && <div className="text-sm text-right">{division.jigyoCount} 件</div>} */}
                            <ChevronRight />
                        </div>
                    </Button>
                ))}
            </CardContent>
        </Card>
    );
}
